export const SHIPPERHQ_ELIGIBLE_STORE_IDS = [13, 14, 28, 58, 163];
